import React from 'react'
import cx from 'classnames'
import { Popover } from '@manychat/manyui'

export interface IProps {
  renderAnchor: (isSelected: boolean) => React.ReactElement
  isSelected: boolean
  renderPopover?: () => React.ReactElement
  onPopoverRequestClose?: (reason: string) => void
  popoverOpen?: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  className?: string
}

const ToolbarItem = ({
  renderAnchor,
  isSelected,
  renderPopover,
  onPopoverRequestClose,
  popoverOpen,
  onClick,
  className,
}: IProps) => {
  const rootRef = React.useRef(null)

  const popover = renderPopover && (
    <Popover
      open={popoverOpen}
      anchor={rootRef.current}
      arrow
      at="bottom"
      onRequestClose={onPopoverRequestClose}
      useLayerForClickAway={false}
      autoPosition="none flip"
      preventBodyScroll
    >
      {renderPopover()}
    </Popover>
  )

  return (
    <>
      <div
        ref={rootRef}
        onClick={onClick}
        className={cx('d-flex flex-row align-center justify-center', className)}
      >
        {renderAnchor(isSelected)}
      </div>
      {popover}
    </>
  )
}

export default ToolbarItem
